/* eslint-disable operator-linebreak */
/* eslint-disable semi */
/* eslint-disable no-param-reassign */
// ============================================================================
// BLACK FRIDAY
// ============================================================================

// Definisco le date del Black Friday, del Black Weekend e del Cyber Monday
const BLACKFRIDAY = {
  start: {
    friday: new Date('November 21, 2023 00:00:00'),
    weekend: new Date('November 25, 2023 00:00:00'),
    cyber: new Date('November 27, 2023 00:00:00'),
  },

  end: {
    friday: new Date('November 21, 2023 23:59:59'),
    weekend: new Date('November 25, 2023 23:59:59'),
    cyber: new Date('November 27, 2023 23:59:59'),
  },
}

// Funzione di aggiornamento del countdown del black friday
function blackFridayCounter(contatore, end) {
  const now = new Date()
  const diff = Date.parse(end) - now

  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor(diff / (1000 * 60 * 60))
  const mins = Math.floor(diff / (1000 * 60))
  const secs = Math.floor(diff / 1000)

  const dd = days
  const hh = hours - days * 24
  const mm = mins - hours * 60
  const ss = secs - mins * 60

  if (dd > 0) {
    contatore.innerHTML =
      dd + ' giorno ' + hh + ' ore ' + mm + ' minuti ' + ss + ' secondi'
  } else {
    contatore.innerHTML = hh + ' ore ' + mm + ' minuti ' + ss + ' secondi'
  }
}

$(document).ready(function () {
  const now = new Date()
  let end = new Date()

  // Black Friday
  // eslint-disable-next-line max-len
  if (
    now.getTime() > BLACKFRIDAY.start.friday.getTime() &&
    now.getTime() < BLACKFRIDAY.end.friday.getTime()
  ) {
    end = BLACKFRIDAY.end.friday

    // Black Weekend
    // eslint-disable-next-line max-len
  } else if (
    now.getTime() > BLACKFRIDAY.start.weekend.getTime() &&
    now.getTime() < BLACKFRIDAY.end.weekend.getTime()
  ) {
    end = BLACKFRIDAY.end.weekend

    // Cyber Monday
    // eslint-disable-next-line max-len
  } else if (
    now.getTime() > BLACKFRIDAY.start.cyber.getTime() &&
    now.getTime() < BLACKFRIDAY.end.cyber.getTime()
  ) {
    end = BLACKFRIDAY.end.cyber
  } else {
    return
  }

  // counter nel banner testata personalizzata black friday
  if ($('#black-friday-counter').length) {
    setInterval(function () {
      blackFridayCounter($('#black-friday-counter')[0], end)
    }, 1000)
  }

  // counter nel banner homepage
  if ($('#black-friday-home-counter').length) {
    setInterval(function () {
      blackFridayCounter($('#black-friday-home-counter')[0], end)
    }, 1000)
  }

  // counter nelle categorie black friday
  if ($('#black-friday-header-counter').length) {
    setInterval(function () {
      blackFridayCounter($('#black-friday-header-counter')[0], end)
    }, 1000)
  }

  // counter nel dettaglio articolo
  if ($('#bfcountdown').length) {
    setInterval(function () {
      blackFridayCounter($('#bfcountdown')[0], end)
    }, 1000)
  }

  // Counter testata (header) desktop
  if ($('#bf-top-desktop').length) {
    setInterval(function () {
      blackFridayCounter($('#bf-top-desktop')[0], end)
    }, 1000)
  }

  // Counter testata (header) mobile
  if ($('#bf-top-mobile').length) {
    setInterval(function () {
      blackFridayCounter($('#bf-top-mobile')[0], end)
    }, 1000)
  }
})

// eslint-disable-next-line no-unused-vars
function showPromoLabel() {
  const promocurrent = new Date()
  const promostart = new Date('November 6, 2017 00:00:00')
  const promoends = new Date('November 12, 2017 23:59:59')

  // eslint-disable-next-line max-len
  if (
    promocurrent.getTime() > promostart.getTime() &&
    promocurrent.getTime() < promoends.getTime()
  ) {
    $('.promotional-label').removeClass('hidden') // bollino gallery
    $('.promotional-details').removeClass('hidden') // fascia dettaglio
  }
}

$(document).ready(function () {
  // attivare solo in caso di promo
  // showPromoLabel();
})

$(document).ajaxComplete(function () {
  // attivare solo in caso di promo
  // showPromoLabel();
})

if ($('#promoDiffPrice').length) {
  const fullPrice = $('#full-price')
    .text()
    .trim()
    .substr(1)
    .replace(/\./g, '')
    .replace(/,/g, '.')
  const finalPrice = $('#final-price')
    .text()
    .trim()
    .substr(1)
    .replace(/\./g, '')
    .replace(/,/g, '.')
  const diffPrice = fullPrice - finalPrice
  $('#promoDiffPrice').text(diffPrice.toFixed(2).replace(/\./g, ','))
}
